export enum OtpMethod {
  GoogleAuth,
  MicrosoftAuth,
  Yubikey,
}
